function isArrayIndex(x) {
	return (parseInt(x).toString() === "" + x) && (x >= 0);
}


function validateArrayBindings(column_bindings, columns_bindings) {
	var mssg;

	var column_ok = Object.keys(column_bindings).every(function(key) {
		return isArrayIndex(column_bindings[key]);
	});

	if (!column_ok) {
		mssg = "All column_bindings values should be non-negative integers";
		throw new TypeError(mssg);
	}

	var columns_ok = Object.keys(columns_bindings).every(function(key) {
		var value = columns_bindings[key];
		return Array.isArray(value) ? value.every(isArrayIndex) : isArrayIndex(value);
	});

	if (!columns_ok) {
		mssg = "All columns_bindings values should be non-negative integers or arrays thereof";
		throw new TypeError(mssg);
	}
}


export { validateArrayBindings };
